import { serviceId } from '@/utils/const';

const DEFAULT_SERVICE_ID = serviceId.basic;

const getDefaultState = () => ({
  serviceList: [],
  basicServiceId: null,
});

const state = getDefaultState();

const mutations = {
  RESET_STATE(currentState) {
    Object.assign(currentState, getDefaultState());
  },
  SET_SERVICE_LIST(currentState, serviceList) {
    currentState.serviceList = Array.isArray(serviceList) ? serviceList : [];
  },
  SET_BASIC_SERVICE_ID(currentState, serviceId) {
    currentState.basicServiceId = serviceId ?? currentState.basicServiceId;
  },
};

const actions = {
  setServiceList({ commit }, serviceList) {
    commit('SET_SERVICE_LIST', serviceList);
    if (Array.isArray(serviceList)) {
      const basicService = serviceList.find((service) => service?.serviceId === DEFAULT_SERVICE_ID);
      if (basicService?.serviceId) {
        commit('SET_BASIC_SERVICE_ID', basicService.serviceId);
      }
    }
  },
  setBasicServiceId({ commit }, serviceId) {
    commit('SET_BASIC_SERVICE_ID', serviceId);
  },
  resetService({ commit }) {
    commit('RESET_STATE');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
